import React from 'react';
import {withRouter} from 'react-router-dom';

import {translate} from 'iss/strings';
import {removeQuestionGroupFromQuestion, subscribeToQuestion} from 'iss/service/QuestionService';
import {Button} from 'iss/widgets/Buttons';
import {FormWithState} from 'iss/widgets/Forms';
import {RestResultMessage, SuccessBox} from 'iss/widgets/MessageBox';

const QuestionEditor = withRouter(subscribeToQuestion(class QuestionEditor extends React.Component {

  state = {
    backendError: null,
  };
  removeGroup = (group) => {
    const {question} = this.props;

    removeQuestionGroupFromQuestion(question.id, group.id).subscribe(
      () => this.props.history.push("/questions/"+question.id + "?success=true"),
      (errorResponse) => this.setState({backendError: errorResponse})
    );
  };

  render() {
    const {question} = this.props;
    const showSuccessMessage = this.props.history.location.search.indexOf("success=true") != -1;

    return <FormWithState initialValues={question} className="tight-form-controls">
      <SuccessBox id="submitSuccess" message={showSuccessMessage ? translate('common.removedSuccessfully') : null} />
      <h1>{translate('questionEditor.title')}</h1>
      <QuestionInfo question={question} />
      <section>
        <h2>{translate('domain.question.groups')}</h2>
        <table id="question-groups-table" className="table table-striped">
          <tbody>
            {question.questionGroups.map(group => {
              return <tr key={group.id} data-group-id={group.id}>
                <td>{group.description}</td>
                <td>
                  <Button id={"remove-group-"+group.id} className="remove-group-button" size="xs"
                    buttonLook="danger" icon="remove" alt={translate("questionEditor.removeGroup")}
                    onClick={() => this.removeGroup(group)} />
                </td>
              </tr>;
            })}
          </tbody>
        </table>
        <RestResultMessage id="groupRemoveError" result={this.state.backendError} />
      </section>;
      <Button link="/questions">
        {translate('questionEditor.backToList')}
      </Button>
    </FormWithState>;
  }
}));

function QuestionInfo({question}) {
  return <table id="question-info" className="table table-striped">
    <tbody>
      <tr id="question-name">
        <th>{translate('domain.question.name')}</th>
        <td>{question.name}</td>
      </tr>
      <tr id="question-description">
        <th>{translate('domain.question.description')}</th>
        <td>{question.description}</td>
      </tr>
      <tr id="question-heading-title">
        <th>{translate('domain.question.headingTitle')}</th>
        <td>{question.headingTitle}</td>
      </tr>
      <tr id="question-form-name">
        <th>{translate('domain.question.formName')}</th>
        <td>{question.formName}</td>
      </tr>
    </tbody>
  </table>;
}

export default QuestionEditor;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/QuestionEditor.jsx